import React, { Children } from "react";
import { useStore } from "../../store";
import { LOG_OUT } from "../../Page/LogIn/types";
import {
  REACT_APP_IMG_BASE_URL,
  REACT_LOCAL_APP_IMG_BASE_URL,
} from "../../ImageConst";
import "./Avatar.scss";
import "../../App.css";
interface AvatarProps {
  className: string;
  userName: string;
  src: string;
  alt: string;
  // width:
}

const Avatar: React.FC<AvatarProps> = (props) => {
  const [state, dispatch] = useStore();

  let getInitials = props?.userName?.toUpperCase().split(" ");
  const FirstName = getInitials && getInitials[0];
  const LastName = getInitials && getInitials[1];

  const initials = FirstName?.charAt(0) + LastName?.charAt(0);

  return (
    <>
      <div
        className={`avatar ${props.className} dropdown-toggle`}
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        {props.src === null ? (
          <div
            style={{
              justifyContent: "center",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              borderRadius: "50%",

              width: "75%",
              height: "75%",
              backgroundColor: "#4492cf",
              color: "white",
              fontWeight: "bold",
              fontSize: "1.25rem",
            }}
          >
            {initials}
          </div>
        ) : (
          <img
            src={`${REACT_APP_IMG_BASE_URL}${props.src}`}
            alt={props.alt}
            // style={{ width: props.width, height: props.width }}
          />
        )}
      </div>

      <ul className="dropdown-menu">
        <li>
          <span
            className="dropdown-item fw-bold name"
            style={{ textTransform: "capitalize" }}
          >
            {state?.userReducer?.specificUser?.name}
          </span>
          <span className="dropdown-item id">
            ID: {state?.userReducer?.specificUser?.dfs_id}
          </span>
        </li>
        <li>
          <a
            className="dropdown-item"
            href="#"
            onClick={() => dispatch({ type: LOG_OUT })}
          >
            Logout
          </a>
        </li>
      </ul>
    </>
  );
};

export default Avatar;
